import type { Category, Video } from "@/types";

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return String(views);
}

export function formatDate(date: string): string {
  const [y, m, d] = date.split("-");
  return `${y}-${m}-${d}`;
}

export function relativeDate(date: string): string {
  const target = new Date(date).getTime();
  const now = Date.now();
  const diffDays = Math.floor((now - target) / (1000 * 60 * 60 * 24));
  if (diffDays <= 0) return "今天";
  if (diffDays === 1) return "昨天";
  if (diffDays < 7) return `${diffDays}天前`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}周前`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)}个月前`;
  return `${Math.floor(diffDays / 365)}年前`;
}

export function findCategory(categories: Category[], slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}

export function findVideo(videos: Video[], id: string): Video | undefined {
  return videos.find((v) => v.id === id);
}

export function searchVideos(videos: Video[], keyword: string): Video[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return videos.filter(
    (v) =>
      v.title.toLowerCase().includes(key) ||
      v.description.toLowerCase().includes(key) ||
      v.tags.some((t) => t.toLowerCase().includes(key)),
  );
}

export function relatedVideos(videos: Video[], current: Video, count = 8): Video[] {
  const sameCategory = videos.filter((v) => v.category === current.category && v.id !== current.id);
  const others = videos.filter((v) => v.category !== current.category && v.id !== current.id);
  return [...sameCategory, ...others].slice(0, count);
}

export type SortKey = "latest" | "hot" | "oldest";

export function sortVideos(list: Video[], sort: SortKey): Video[] {
  const copy = [...list];
  if (sort === "latest") {
    copy.sort((a, b) => (a.uploadDate < b.uploadDate ? 1 : -1));
  } else if (sort === "oldest") {
    copy.sort((a, b) => (a.uploadDate > b.uploadDate ? 1 : -1));
  } else {
    copy.sort((a, b) => b.views - a.views);
  }
  return copy;
}